import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import dynamic from 'next/dynamic';
const ImageWrapper = dynamic(() => import('../ImageWrapper'), { ssr: false });

const ImagesWithTitle = (props: any) => {
    const { heading, showAssuranceTag = false, imagesData = [] } = props;
    return (
        <ImagesWithTitleWrapper>
            <ImageTitleContainer>
                <ImageTitle>{heading}</ImageTitle>
                {showAssuranceTag && (
                    <AssuranceTag>
                        {'Assurance '}
                        <Image
                            src={resolvePath('/images/seo/Assured.svg')}
                            width={16}
                            height={16}
                            alt={'assuredIcon'}
                        />
                    </AssuranceTag>
                )}
            </ImageTitleContainer>
            {imagesData?.map((imageData: any) => {
                return (
                    <ImageWrapper
                        srcImg={imageData?.imageUrl?.data.attributes.url}
                        fullWidth={imageData?.fullWidth}
                    />
                );
            })}
        </ImagesWithTitleWrapper>
    );
};

export default ImagesWithTitle;

const ImagesWithTitleWrapper = styled.div`
    display: flex;
    padding: var(--spacing-20px, 20px) var(--spacing-16px, 16px) 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
`;
const ImageTitleContainer = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    gap: 4px;
    align-self: stretch;
    flex-wrap: wrap;
    & > * {
        flex-basis: 100%;
    }
`;

const ImageTitle = styled.h2`
    color: var(--Text-Primary-grey600, #121212);
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 140% */
    letter-spacing: -0.1px;
    margin: 0;
`;

const AssuranceTag = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    align-self: stretch;

    color: var(--button-hover-g-400, #0b753e);
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 140% */
    letter-spacing: -0.1px;
`;
